import type {
  IFilterData,
  IFilterDataArray,
} from '@rankmi/rankmi-table/dist/interfaces/filterProps'
import { Modal } from 'react-bootstrap'
import { useMemo } from 'react'
import { Segment } from 'models/segment.model'
import { useTranslationRankmi } from 'helpers/translations.helper'
import { Table } from './Table'

interface SegmentModalProps {
  open: boolean
  onClose: () => void
  segment?: Segment
}

export const SegmentModal = ({ open, onClose, segment }: SegmentModalProps) => {
  const t = useTranslationRankmi({
    prefix: 'configuration.segments.usersModal',
  })
  const filterData = useMemo(
    (): IFilterData => ({
      filterType: 'simple',
      data: [
        {
          input: 'segments_id',
          condition: 'and',
          operator: 'eq',
          compareTo: segment?.id as IFilterDataArray['compareTo'],
        },
      ],
    }),
    [segment]
  )
  return (
    <Modal size="xl" show={open} onHide={onClose}>
      <Modal.Header closeButton>
        <Modal.Title className="m-0">
          {t('title', {
            name: segment?.name || '...',
          })}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {!!segment?.id && <Table filterData={filterData} />}
      </Modal.Body>
    </Modal>
  )
}
